import {PaymentProvider, TenantConfig, TenantConfigServices} from "../../types/tenantConfig";
import logo from "./assets/logo/logo.webp";

const paymentProvider: PaymentProvider[] = process.env
  .REACT_APP_PAYMENT_PROVIDER
  ? (process.env.REACT_APP_PAYMENT_PROVIDER.split(",") as PaymentProvider[])
  : [];

export const Config: TenantConfig = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL!,
    key: process.env.REACT_APP_API_KEY!,
  },
  gtm: {
    id: process.env.REACT_APP_GTM_ID!,
    auth: process.env.REACT_APP_GTM_AUTH!,
    preview: process.env.REACT_APP_GTM_PREVIEW!,
  },
  seo: {
    appTitle: "software for smart sharing",
    appDescription:
      "kolula ermöglicht kontaktlose Übergabe von Waren, den einfachen Zugang zu Produkten und sichereres temporäres Verwahren von Gegenständen.",
    ogTitle: "Software für smartes Sharing",
    ogDescription:
      "kolula ermöglicht kontaktlose Übergabe von Waren, den einfachen Zugang zu Produkten und sichereres temporäres Verwahren von Gegenständen.",
    ogImage: logo,
    ogUrl: "https://www.kolula.com/",
  },
  languages: ["en"],
  fallbackLng: "en",
  currency: "NOK",
  currencySymbol: "kr",
  paymentProvider: paymentProvider,

  phoneInput: {
    defaultCountry: "no",
    preferredCountries: ["no", "de", "at", "ch", "nl", "be"],
  },

  contact: {
    phone: "+4791170725",
    phoneFormatted: "+47 911 70 725",
  },
  toolbarItems: ["home", "orders", "locations", "info"],
  optionalScreens: [
    "orderItemDetails",
    "responsibilityExplanation",
    "orderOverview",
    "partnerUscInformation",
  ],
  bookingFlow: [
    "locationSelection",
    "assetGroupSelection",
    "orderData",
    "confirmation",
    "personalData",
    "paymentTypeSelection",
    "payment",
  ],
  // startPage: 'none',
  allowCoupons: true,
  allowNewsLetter: false,
  consentRequired: true,
  services: ["sup", "moreToCome", "voucher"] as TenantConfigServices,
  email: "vic.eversley@gmail.com",
  content: {
    de: { moreToCome: {header_text: "Neues bei kolula SUP", first_text: "Danke, dass du dich für kolula SUP interessierst! Wir arbeiten daran, das Angebot zu erweitern, z.B. um SUP-Kurse, Trainerstunden oder weitere Mietprodukte. Unser Ziel ist es, dir noch mehr Services für einen perfekten Tag am Strand zu bieten - direkt vor Ort, jederzeit flexibel zugänglich.", second_text: "Wir freuen uns über Deine Meinung! Schicke uns deine Ideen für kolula SUP oder gib uns Feedback zum aktuellen Konzept und sende es per E-Mail an {email}." } },
    en: { moreToCome: {header_text: "News at kolula SUP", first_text: "Thank you for your interest in kolula SUP!  We are working on expanding our offer, e.g. with SUP courses, coaching lessons or other rental products. Our goal is to offer you even more services for a perfect day at the beach - directly on site, flexibly accessible at any time.", second_text: "We would love to hear your opinion! Send us your ideas for kolula SUP or give us feedback on the current concept and send it by e-mail to {email}." } },
  },
  isEnableLocationVerification: false,
  gracePeriodMinutes: 15,
};

export default Config;
